import { render } from "./refundManage.vue?vue&type=template&id=709378da&scoped=true"
import script from "./refundManage.vue?vue&type=script&lang=js"
export * from "./refundManage.vue?vue&type=script&lang=js"

import "./refundManage.vue?vue&type=style&index=0&id=709378da&scoped=true&lang=css"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-709378da"]])

export default __exports__